module.exports = __webpack_public_path__ + "static/img/coupon_border.16aee94.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/coupon_border.png
// module id = Cla7
// module chunks = 6